var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card-footer-item",on:{"click":function($event){$event.preventDefault();return _vm.doSomething($event)}}},[_c('b-icon',{attrs:{"icon":"autorenew","custom-size":"default"}}),_c('span',[_vm._v("Load more")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }